export function conferirResultadosHabilitado(): boolean {
  return import.meta.env.VITE_APP_CONFERIRRESULTADOS === "true";
}
